
import { useState, createRef, useEffect } from 'react'
import classNames from 'classnames'

import messagesService from '@/app-domains/messages/messages.service'
import useRenderEvent from '@/core/hooks/useRenderEvent'
import './ShowMoreHeight.sass'
import store from '@/core/store'

export function ShowMoreHeight (props) {
  const { height, thread } = props
  
  const [showFull, setShowFull] = useState(false)
  const [shouldShowLessButton, setShouldShowLessButton] = useState(false)
  const [renderToggle, setRenderToggle] = useState(false)
  const [needsShowMore, setNeedsShowMore] = useState(null)
  const [message, setMessage] = useState(props.message)
  const $readMoreButton = createRef()
  const $content = createRef()

  useRenderEvent([`THREAD:${thread.composedid}:UPDATE:READ`], () => {
    setMessage({ ...message, unopen: false })
  })

  const triggerShowFull = (val, triggerScroll = false) => {
    setTimeout(() => store.commit('MESSAGE:EXPANDED:SWITCH', val), 100)
    setShowFull(val)
    setShouldShowLessButton(val)
    if (val && message?.unopen) {
      messagesService.markMessageAsRead(message.id, thread.composedid, thread.boxId)
    }
    if (!val && triggerScroll) {
      setTimeout(() => {
        const header = document.querySelector(`section[_message="${props.message.id}"] header`)
        if (header) {
          header.scrollIntoView({ behavior: 'smooth' })
        }
      }, 0)
    }
  }

  useRenderEvent([`MESSAGE_EXPANDED:${props.message.id}:FLOATING_READ_LESS_BUTTON`], (val) => {
    setShouldShowLessButton(val)
  })

  useEffect(() => {
    if (!$content?.current) return
    setNeedsShowMore($content.current.clientHeight > height)
  })

  useEffect(() => {
    setTimeout(() => {
      setRenderToggle(!renderToggle)
    }, 400)
  }, [])

  return <div className={
    classNames('ShowMoreHeight',
      {
        needs_show_more: needsShowMore,
        not_show_more: !needsShowMore,
        show_full: showFull,
        unread: message.unopen
      }
    )}
    _thread={thread.composedid}
    _message={message.id}
    _unread={message.unopen ? 'true' : 'false'}
    onClick={(e) => {
      if (!showFull && needsShowMore) {
        triggerShowFull(!showFull)
      }
      e.stopPropagation()
    }}>
    <div className="-wrapper">
      {showFull && shouldShowLessButton && <div className='message-read-less-collapse' onClick={() => triggerShowFull(!showFull, true)}>Show less</div>}
      <div className="-content" ref={$content}>
        {props.children}
      </div>
    </div>
    <div ref={$readMoreButton} className="-show_more" onClick={(e) => e.stopPropagation()}>
      { needsShowMore &&
        <span onClick={() => triggerShowFull(!showFull, true)}>{showFull ? 'Show less' : 'Show more...'}</span>
      }
    </div>
  </div>
}
